(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var sortSelect = document.getElementById('sort-select');

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var grid = document.getElementById('collection-grid');
        if (!grid) return;
        var cards = Array.from(grid.querySelectorAll('.collection-card'));
        var sortVal = sortSelect.value;

        cards.sort(function(a, b) {
          switch (sortVal) {
            case 'price-ascending':
              return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
            case 'price-descending':
              return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
            case 'title-ascending':
              return a.dataset.title.localeCompare(b.dataset.title);
            case 'title-descending':
              return b.dataset.title.localeCompare(a.dataset.title);
            case 'created-ascending':
              return (parseInt(a.dataset.date) || 0) - (parseInt(b.dataset.date) || 0);
            case 'created-descending':
              return (parseInt(b.dataset.date) || 0) - (parseInt(a.dataset.date) || 0);
            default:
              // featured / best-selling / manual — keep original HTML order
              return 0;
          }
        });

        cards.forEach(function(card) { grid.appendChild(card); });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
